import { Alert, ProgressBar } from "react-bootstrap"
import React from "react"
import request from "./request"
import marked from "marked"

export default function Messages({ uid, messages, onDismiss }) {
	const alerts = []
	for (const id of Object.keys(messages)) {
		if (messages[id] === null) {
			continue
		}
		const { message, level = "info", from, progress } = messages[id]
		const html = marked(message, { sanitize: true })
		alerts.push(
			<Alert
				bsStyle={level}
				onDismiss={dismissHandler(uid, id, from, onDismiss)}
				key={id}
			>
				<div
					className="message-content"
					dangerouslySetInnerHTML={{
						__html: html,
					}}
				/>
				{progress ? (
					<ProgressBar className="payment-progress" active now={100} />
				) : null}
			</Alert>
		)
	}
	return <div>{alerts}</div>
}

function dismissHandler(uid, id, from, onDismiss) {
	return () => {
		if (from === "client") {
			onDismiss(id)
		} else {
			request(uid, {
				action: "dismiss",
				payload: id,
			})
		}
	}
}



// WEBPACK FOOTER //
// ./src/Messages.js